import { render, staticRenderFns } from "./LeakageCauseLocationHouseQuestion.vue?vue&type=template&id=5960262d&scoped=true"
import script from "./LeakageCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseLocationHouseQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960262d",
  null
  
)

export default component.exports